<template>
  <v-container fluid>
    <v-layout row v-if="loading">
      <v-progress-linear indeterminate />
    </v-layout>

    <v-layout v-else column id="employee-schedule-container">
      <v-flex v-for="(shift, i) in schedule" :key="shift.id">
        <ShiftWithDetails
          :itemData="shift"
          :stripe="i % 2 != 0"
          admin
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ShiftWithDetails from '@/components/shifts/shiftWithDetails.vue'

export default {
  components: {
    ShiftWithDetails
  },
  mounted: function() {
    this.loading = true
    this.$store.dispatch('hr/getSchedule', this.employee.id).finally(() => {
      this.loading = false
    })
  },
  props: [
    'employee'
  ],
  computed: {
    ...mapState('hr', [
      'workHistory',
      'workHistoryStats',
      'schedule'
    ]),
  },
  data: function() {
    return {
      loading: false,
      defaultSort: {
        sortBy: 'startDatetime',
        descending: true,
        rowsPerPage: -1,
      },
      headers: [
        {
          text: 'Date',
          value: 'startDatetime',
        },
        {
          text: 'Location',
          value: 'location',
        },
        {
          text: 'Start Time',
          value: 'clockInTime'
        },
        {
          text: 'End Time',
          value: 'clockOutTime'
        },
        {
          text: 'Hours Worked',
          value: 'hoursWorked',
        },
        {
          text: 'Diff',
          value: 'diff'
        },
      ],
    }
  },
  methods: {
  }

}
</script>

<style scoped>
  #employee-schedule-container {
    max-height: 80vh;
    overflow-y: scroll;
  }
</style>
